import Label from './Label';

export { Props, Action, labelID } from './Label';
export default Label;
